import React, {useContext, useEffect, useState} from 'react';
import {TableColumn, TableSettings} from "../../../tableSettings";
import AbstractListView, {
  DataFetchResult,ExportRowRenderer,ListCustomFilterRenderer,ListOrderBy,ListRowRenderer
} from "../../common/AbstractListView";
import constants from '../../../constants';
import {amsUsersList,} from '../tableSettings';
import {Search} from "../../../filtering";
import {
  DateRenderer,DateTimeRenderer,NullableCheckboxIconRenderer,TextAlignLeftRenderer,TextRenderer
} from '../../../uiControls/SmartTableRenderers';
import JobListViewContext, { IJobListViewContext, RightClickContext } from '../../common/JobListViewContext';
import useFunctionKeys from '../../../hooks/useFunctionKeys';
import {JobNames} from '../../../framework.core/JobNames';
import {AmsUserListItem} from '../../../fms.data/models/AmsUserListItem';
import * as XCol from '../../../framework.core/XExportColumn';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCopy, faFileAlt, faPencilAlt, faPlus, faTrashAlt} from "@fortawesome/free-solid-svg-icons";
import PrimaryButton from "../../../ui/PrimaryButton";
import { ActionButtonItem, borderColors, splitMenuItemsIntoSections } from '../../../ui/ActionButton';
import ToolboxMenuItem from '../../../uiControls/ToolboxMenuItem';
import Menu, { IfmsMenuItem } from '../../../ui/menu/Menu';
import ViewUser from './implementation/ViewUser';
import IfmsModal from '../../../ui/IfmsModal';
import { findSecurityTask } from '../../../util';
import ApplicationContext from '../../../ApplicationContext';
import { FmsSecTask } from '../../../fms.core/constants';
import { nullableCheckBoxValue } from '../../common/commonExportFormat';


function RightClickMenu({dismiss}:{dismiss: VoidFunction}) {
  // const { view } = useSelectedOperations();
  const jobListContext = useContext(JobListViewContext);
  // const selectedElement = jobListContext.selectedElement as OceanQuoteListItem;
  // const appContext = useContext(ApplicationContext);
  // const [showGlobalOkDialog] = useGlobalOkDialog();

  const items = [
    { label: 'New', shortcut: 'F2', separator: false },
    { label: 'View', shortcut: 'F9', separator: false },
    { label: 'Edit', shortcut: 'F3', separator: true },
    { label: 'Search', shortcut: 'F5', separator: false },
    { label: constants.Doc_Server, shortcut: 'F8', separator: true, newCol: true },
    { label: 'Copy', shortcut: 'Ctrl+F2', separator: false },
  ];

  const menuItems: ActionButtonItem[] = items.map((i, index) =>({
    label: <ToolboxMenuItem width="190px" label={i.label} shortcut={i.shortcut} />,
    separator: i.separator,
    selected: false,
    newCol: i.newCol,
    index,
  }));

  function onMenuItemSelected(item:IfmsMenuItem) {
    switch (item.index) {
      // case 0:
      //   view();
      //   break;
      // case 1:
      //   switchToAmsHbl();
      //   break;
      case 3:
        jobListContext.triggerTableSearch('F5');
        break;
      // case 3:
      //   switchToAmsMbl();
      //   break;
      case 4:
        jobListContext.setInfoAreaContent(jobListContext.infoAreaContent === 'memo' ? 'none' : 'memo');;
        break;
      case 5:
        jobListContext.reloadData();
        break;
      default:
        break;
    }
    dismiss();
  }

  return (
    <Menu
      variant="plain"
      specialMenu='rightClickContext'
      items={splitMenuItemsIntoSections(menuItems)}
      mode="vertical"
      onMenuItemSelected={onMenuItemSelected}
      subMenuStyle={{
        minWidth: 150,
        whiteSpace: 'nowrap',
      }}
      menuStyle={(i: number) => ({
        maxHeight: '300px',
        overflowY: 'hidden',
        padding: 0,
        borderTop: `3px solid ${borderColors[i % borderColors.length]}`,
        paddingTop: 10,
      })}
      dismiss={dismiss}
    />
  );
}

function ViListCommands() {
  const [popupMode, setPopupMode] = useState('none');
  const jobListContext = useContext(JobListViewContext);
  const appContext = useContext(ApplicationContext);
  
  const selectedElement = jobListContext.selectedElement as AmsUserListItem;
  const listSec = findSecurityTask(appContext, FmsSecTask.AMSUser);
  
  function dismissUserView() {
    setPopupMode('none');
    jobListContext.dismissPopupRow();
  }

  const hasSelectedRow = !!selectedElement;
  const canBeDeleted = hasSelectedRow && listSec?.grantDel;
  const canBeCopied = hasSelectedRow && listSec?.grantAdd;

  return (
    <div className={!appContext.useDarkMode ? "ifms-common-vertical-separator" : "ifms-common-vertical-separator-darkmode"}>
      <div className="ifms-common-no-vertical-separator">
        <PrimaryButton name='amsUser-list-add-button' size="regular" disabled={!hasSelectedRow} onClick={() => setPopupMode('new')}>New</PrimaryButton>&nbsp;
        <PrimaryButton name='amsUser-list-view-button' size="regular" disabled={!hasSelectedRow} onClick={() => setPopupMode('view')}>View</PrimaryButton>&nbsp;
        <PrimaryButton name='amsUser-list-edit-button' size="regular" disabled={!hasSelectedRow} onClick={() => setPopupMode('edit')}>Edit</PrimaryButton>&nbsp;
        <PrimaryButton name='amsUser-list-delete-button' size="regular" disabled={!canBeDeleted}>Delete</PrimaryButton>&nbsp;
        <PrimaryButton name='amsUser-list-copy-button' size="regular" disabled={!canBeCopied}>Copy</PrimaryButton>
      </div>
      <IfmsModal isBlueHeader onCancel={dismissUserView} draggable isOpen={popupMode !== 'none' || !!jobListContext.viewPopupRow} title="View User" width="760px">
        <ViewUser onPopupClose={dismissUserView} mode={popupMode} selectedElementId={popupMode === 'edit' || popupMode === 'view' ? selectedElement?.id ?? '' : ''} />
      </IfmsModal>
    </div>
  );
}

function ViListToolbar() {
  return null;
}

function formatData(data:Array<AmsUserListItem>) {
  return data;
}

function ViListViewExtras() {
  useFunctionKeys({onFunction: onFunctionKey});

  const jobListContext = useContext(JobListViewContext);

  const [unprocessedFkey, setUnprocessedFkey] = useState<string|null>(null);

  useEffect(() => {
      if (!unprocessedFkey) {
        return;
      }

      doProcessFkey();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [unprocessedFkey]
  );

  function doProcessFkey() {
    if (unprocessedFkey === "F11") {
      jobListContext.reloadData();
    }

    setUnprocessedFkey(null);
  }

  function onFunctionKey(fkey:string) {
    if (['F11'].indexOf(fkey) >= 0) {
      setUnprocessedFkey(fkey);
      return true;
    }

    return false;
  }

  return null;
}

/**
 * Concrete implementation for AMS User List screen
 *
 * @class UsersListView
 * @extends {AbstractListView}
 */
 class UsersListView extends AbstractListView {
  async fetchAndFormatData(api: any, search: Search, opType :any): Promise<DataFetchResult> {
    const apiResult = await api.getListItems(JobNames.AMSUser, 'AmsUserListItem',
    AmsUserListItem.calculateSearchParameters(search),
      1,
      search.pageSize,
      'AMS');
    if (!apiResult || !apiResult.entities || apiResult.entities.length <= 0) {
      return {data: [], totalCount: 0};
    }

    return { data: formatData(apiResult.entities), totalCount: apiResult.totalCount};
  }

  getCustomFilterRenderers(): ListCustomFilterRenderer[] {
    return [
    ];
  }

  getInfoAreaEntityId() {
    return constants.infoAreaEntity.oceanImportMbl;
  }

  getRowRenderers(): ListRowRenderer[] {
    return AmsUserListItem.getExportCollection().map(x => {
      const colRenderer:ListRowRenderer = { accessor: x.dataIndex, Cell: TextAlignLeftRenderer };
      if(x.align === XCol.XAlignType.Center) colRenderer.Cell = TextRenderer;
      if(x.dataIndex === "status") {
        colRenderer.Cell = () => <span></span>
        colRenderer.Header = () => <span></span>;
      }
      else if(x.type === XCol.XCellType.Bool || x.type === XCol.XCellType.StrBool) colRenderer.Cell = NullableCheckboxIconRenderer;
      else if(x.type === XCol.XCellType.Date) colRenderer.Cell = DateRenderer;
      else if(x.type === XCol.XCellType.DateTime) colRenderer.Cell = DateTimeRenderer;
      return colRenderer;
    });
  }
  
  getExportRenderers(): ExportRowRenderer[] {
    const colRenderer = [];
    colRenderer.push({accessor: 'status', changedValue: (value: any)=> { return value['status'] === 'PC' ? 'Period Close' : ''}});    
    colRenderer.push({accessor: 'active', changedValue: (value: any)=> { return nullableCheckBoxValue(value['active'])}});
    return colRenderer;
  }

  getDefaultOrderBy(): ListOrderBy {
    return {
      orderBy: '¨id',
      orderByAscending: false,
    };
  }

  getTableSettings(): TableSettings {
    const tsettings = amsUsersList;
    const cols = AmsUserListItem.getExportCollection();
    tsettings.columns = cols.map<TableColumn>(x => {
      return { ...x, accessor: x.dataIndex, Header: x.text, filterType: undefined, filterTypeV2: x.type};
    });

    return tsettings;
  }

  renderCommands() {
    return (
      <ViListCommands />
    );
  }

  renderBeforeConfigureButton() {
    return (
      <ViListToolbar />
    );
  }


  renderExtras() {
    return <ViListViewExtras />
  }

  getViewUrlFor() {
    return '';
  }

  getListViewTitle() {
    return 'AMS User List';
  };


  hasRightClickContext(): boolean {
    return true;
  }

  renderRightClickContext(context: RightClickContext, dismiss: VoidFunction): React.ReactNode {
    return <RightClickMenu dismiss={dismiss} />;
  }

  hasMemo(): boolean {
    return false;
  }
};

export default UsersListView;